.root {
  position: fixed;
  inset: 0;
  z-index: 500;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.backdrop {
  position: absolute;
  inset: 0;
  background: rgb(0 0 0 / 0.6);
  backdrop-filter: blur(2px);
  animation: fade var(--t-med) var(--ease);
}

.panel {
  position: relative;
  width: min(100%, var(--app-max));
  max-height: 88dvh;
  display: flex;
  flex-direction: column;
  background: var(--surface-1);
  border: 1px solid var(--border);
  border-bottom: 0;
  border-radius: var(--r-xl) var(--r-xl) 0 0;
  box-shadow: var(--shadow-lg);
  padding-bottom: var(--safe-b);
  outline: none;
  animation: up var(--t-slow) var(--ease);
  transition: transform var(--t-fast);
}

.tall {
  height: 85dvh;
}

.closing .panel {
  animation: down 180ms var(--ease) forwards;
}
.closing .backdrop {
  animation: fade 180ms reverse forwards;
}

.handleZone {
  display: grid;
  place-items: center;
  height: 22px;
  cursor: grab;
  touch-action: none;
  flex-shrink: 0;
}

.handle {
  width: 40px;
  height: 4px;
  border-radius: 4px;
  background: var(--surface-4);
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px 6px 20px;
  flex-shrink: 0;
}

.header h2 {
  font-size: var(--fs-md);
  font-weight: 800;
}

.body {
  overflow-y: auto;
  overscroll-behavior: contain;
  flex: 1;
  min-height: 0;
}

.footer {
  border-top: 1px solid var(--border);
  padding: 10px 12px;
  flex-shrink: 0;
}

.actions {
  list-style: none;
  margin: 0;
  padding: 4px 8px 12px;
}

.actions button {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 14px 12px;
  border-radius: var(--r-md);
  font-weight: 600;
  text-align: left;
}

.actions button:hover {
  background: var(--surface-2);
}

.danger {
  color: var(--danger);
}

@keyframes up {
  from {
    transform: translateY(100%);
  }
}
@keyframes down {
  to {
    transform: translateY(100%);
  }
}
@keyframes fade {
  from {
    opacity: 0;
  }
}
